import { withTheme } from 'theme';
import material3 from 'theme/material3';

const container = withTheme((theme) => ({
  width: '100%',
  padding: theme.spacing(2),
  background: material3.color.surfaceContainerLow,
  border: `1px solid ${material3.color.outlineVariant}`,
  borderRadius: material3.shape.large,
  boxShadow: material3.elevation.level1,
  maxWidth: '600px',
  overflow: 'hidden',
  transition: 'border-color .18s ease, box-shadow .18s ease, transform .18s ease',
  '&:hover': {
    borderColor: material3.color.primaryLight,
    boxShadow: material3.elevation.level2,
    transform: 'translateY(-1px)'
  },
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    alignItems: 'flex-start',
  }
}));

const pictureWrapper = withTheme((theme) => ({
  width: '33%',
  maxWidth: '130px',
  aspectRatio: '4/3',
  overflow: 'hidden',
  borderRadius: material3.shape.medium,
  border: `1px solid ${material3.color.outlineVariant}`,
  background: material3.color.surfaceContainer,
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    maxWidth: '160px'
  },
  '& img': {
    display: 'block',
    width: '100%',
    height: '115px',
    objectFit: 'cover'
  }
}));

const infoWrapper = withTheme(() => ({
  width: '100%',
  '& .MuiTypography-h3': {
    color: material3.color.textPrimary
  }
}));

const styles = {
  container,
  pictureWrapper,
  infoWrapper
};

export default styles;
